import $ from "jquery";
import MenuTemplate from "./GalleryMenu.ejs";
import ContentTemplate from "./GalleryContent.ejs";
import ItemVideoTemplate from "./GalleryItemVideo.ejs";
import ItemImageTemplate from "./GalleryItemImage.ejs";
import makeTemplateFunc from "lodash/template";

const MenuTemplateFunc = makeTemplateFunc(MenuTemplate);
const ContentTemplateFunc = makeTemplateFunc(ContentTemplate);
const ItemVideoTemplateFunc = makeTemplateFunc(ItemVideoTemplate);
const ItemImageTemplateFunc = makeTemplateFunc(ItemImageTemplate);

class Gallery {

    constructor() {
        this.$container = $('.js-gallery');
        this.api = this.$container.attr('data-gallery-api');

        $(() => {

            if (this.$container.length) {
                this.init();
            }
        });
    }

    init() {

        this.fetchData((data) => {
            this.$container.html('');
            this.renderMenu(data);
            this.renderItems(data.categories[0].items);
            if ($(window).width() < 768) {
                setTimeout(() => {
                    this.initSlider(data);
                }, 100);
            }
        });


    }

    renderItems(itemsRaw) {

        this.$container.find('.js-gallery-content').remove();

        itemsRaw.map((item, i) => item.index = i);

        const rows = [];
        const items = itemsRaw.slice();
        let item = 0;
        let row = 0;
        let itemsInRow;
        while (items.length) {
            if (row === 0) {
                itemsInRow = 1;
            } else if (row === 4) {
                itemsInRow = 2;
            } else {
                itemsInRow = 3;
            }
            rows.push({ items: items.splice(0, itemsInRow) });
            item++;
            row++;
        }

        rows.map((row, index) => {
            const itemsCount = row.items.length;
            switch (index) {
                case 0:
                    row.type = 1;
                    break;
                case 1:
                    if (itemsCount > 2) {
                        row.type = 2;
                    } else if (itemsCount === 2) {
                        row.type = 4;
                    } else {
                        row.type = 1;
                    }
                    break;
                case 2:
                    if (itemsCount > 2) {
                        row.type = 3;
                    } else if (itemsCount === 2) {
                        row.type = 4;
                    } else {
                        row.type = 1;
                    }
                    break;
                case 3:
                    if (itemsCount > 2) {
                        row.type = 2;
                    } else if (itemsCount === 2) {
                        row.type = 4;
                    } else {
                        row.type = 1;
                    }
                    break;
                case 4:
                    if (itemsCount > 1) {
                        row.type = 4;
                    } else {
                        row.type = 1;
                    }
                    break;
                default:
                    return;
            }

            row.items.map((item) => {
                if (item.type === 'video') {
                    item.html = ItemVideoTemplateFunc({ item });
                } else {
                    item.html = ItemImageTemplateFunc({ item });
                }
                return item;
            });
            return row;
        });
        const contentHtml = ContentTemplateFunc({ rows });
        this.$container.append(contentHtml);

        this.bindItemsEvents(itemsRaw);
    }

    bindItemsEvents(items) {
        this.$container.find('[data-link-to-section]').each((i, el) => {
            const $link = $(el);
            const category = $link.data('link-to-section');
            $link.on('click', (e) => {
                e.preventDefault();
                $(`.tab-menu__link[data-category="${category}"]`).trigger('click');
                $('html, body').animate({
                    scrollTop: 0
                }, 200);
            });
        });

        this.$container.find('.js-zoom-slider').each((i, el) => {
            const index = parseInt($(el).data('slide-number'));
            $(el).on('click', (e) => {
                e.preventDefault();
                this.openPopup(items, index);
            });
        });
    }

    renderMenu(data) {
        const menuHtml = MenuTemplateFunc(data);
        this.$container.append(menuHtml);
        this.bindMenuEvents(data);

    }

    bindMenuEvents(data) {
        this.$container.find('.js-tab-menu-link').each((i, link) => {
            const $link = $(link);
            const currentCategoryCode = $link.data('category');
            $link.on('click', () => {
                if ($(window).width() > 767) {
                    this.onTabChange($link, currentCategoryCode, data);
                }
            });
        })
    }

    onTabChange($link, currentCategoryCode, data) {
        if ($link.is('.active')) {
            return;
        }
        this.$container.find('.js-tab-menu-link.active').removeClass('active');
        $link.addClass('active');
        const category = data.categories.find((category) => category.code === currentCategoryCode);
        this.renderItems(category.items);
    }

    fetchData(callback) {
        let list = {};
        $.ajax({
            type: "GET",
            url: this.api,
            async: false,
            dataType: 'json',
            data: '',
            success: function (data) {
                callback(data);
            },
            error: function () {
                console.error('error');
            }
        });
        return list;
    }

    initSlider(data) {
        if (!this.$container.find('.js-gallery-menu').hasClass('slick-slider')) {

            this.$container.find('.js-gallery-menu').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                cssEase: 'linear',
                speed: 300,
                variableWidth: true,
                settings: 'unslick',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            infinite: true,
                            swipeToSlide: true,
                            swipe: true,
                            focusOnSelect: true,
                            speed: 300,
                            variableWidth: true
                        }
                    }
                ]
            }).on('afterChange', (event, slick, currentSlide) => {
                let $link = this.$container.find('.slick-current .js-tab-menu-link'),
                    currentCategoryCode = $link.data('category');
                this.onTabChange($link, currentCategoryCode, data);
            });
        }
    }

    onPopupOpen(items) {
        const listItems = items,
              listLenght = listItems.length;


        $('<div class="mfp-gallery-list"></div>').appendTo('.mfp-container');

        for (let i = 0; i < listLenght; i++) {
            $(`<a href="${i}" class="mfp-gallery-list__item" style="background-image: url(${listItems[i].thumbnail})"></a>`).appendTo('.mfp-gallery-list');
        }

        $('.mfp-gallery-list__item').eq(0).addClass('current');

        if (listLenght > 5) {
            $('.mfp-gallery-list').slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                centerMode: true,
                prevArrow: '<button class="slider-arrow slider-arrow__left ic-slider-arrow-left mfp-prevent-close" aria-label="Previous" type="button"></button>',
                nextArrow: '<button class="slider-arrow slider-arrow__right ic-slider-arrow-right mfp-prevent-close" aria-label="Next" type="button"></button>'
            });
        }

    }

    setActiveThumbnail(index) {
        $('.mfp-gallery-list__item').removeClass('current');
        $('.mfp-gallery-list__item[href="' + index + '"]').addClass('current');

        if ($('.mfp-gallery-list').is('.slick-initialized')) {
            $('.mfp-gallery-list').slick('slickGoTo', index);
        }
    }

    openPopup(items, currentIndex = 0) {

        const mfp = $.magnificPopup.instance;
        const slider = {
            full: [],
            mini: []
        };

        items.forEach((item, index) => {
            if (item.type === 'image') {
                slider.full.push({ src: item.big , index});
                slider.mini.push({ thumbnail: item.small});
            } else if (item.type === 'video') {
                slider.full.push({ src: item.poster , index});
                slider.mini.push({ thumbnail: item.poster});
            }
        });

        mfp.open({
            type: 'image',
            preloader: false,
            showCloseBtn: false,
            fixedBgPos: true,
            fixedContentPos: true,
            closeOnBgClick: false,
            mainClass: 'mfp-image-holder mfp-no-margins',
            items: slider.full,
            image: {
                verticalFit: true
            },
            gallery: {
                enabled: true,
                preload: 0,
                navigateByImgClick: false,
                arrowMarkup: '<button type="button" class="slider-arrow slider-arrow__%dir% ic-slider-arrow-%dir%"></button>'
            },
            callbacks: {
                open: () => {
                    this.onPopupOpen(slider.mini);
                    $('<button type="button" class="mfp-close ic-close"></button>').appendTo('.mfp-content');
                    mfp.goTo(currentIndex);
                },
                change: (item) => {
                    this.setActiveThumbnail(item.index);
                },
                markupParse: (template, values, item) => {
                    this.setActiveThumbnail(item.index);
                    setTimeout(() => {
                        $('.mfp-content').css({
                            'background-image': 'url(' + item.src + ')'
                        });
                    }, 0);
                }
            }
        }, 0);
    }
}

export default new Gallery();


// WEBPACK FOOTER //
// ./js/components/Gallery/Gallery.js